<script>
import { cmsMenuLayerProps, useCmsMenuLayer } from "./mixin";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import Button from "@/components/atoms/button";

export default {
  name: "CmsMenuLayer",
  components: {
    List,
    ListItem,
    Button
  },
  props: {
    ...cmsMenuLayerProps()
  },
  setup() {
    const { currentChild, showChild, hideChild } = useCmsMenuLayer();
    return {
      currentChild,
      showChild,
      hideChild
    };
  }
};
</script>

<template>
  <div class="c-cms-menu-layer u-flex">
    <div
      :class="currentChild && 'c-cms-menu-layer__panel--opened'"
      class="c-cms-menu-layer__panel"
    >
      <List v-if="category.attributes && category.attributes.children && category.attributes.children.data && category.attributes.children.data.length > 0">
        <ListItem
          v-for="(child, index) in category.attributes.children.data"
          :key="`cms-menu-layer-${index}`"
          class="c-cms-menu-layer__item"
          :class="(currentChild && currentChild.attributes.libelle === child.attributes.libelle) && 'c-cms-menu-layer__item--active'"
        >
          <template v-if="child.attributes.libelle">
            <template v-if="child.attributes.children.data.length > 0">
              <Button
                class="c-cms-menu__nav-button has-child"
                @click="showChild(child)"
              >
                {{ child.attributes.libelle }}
              </Button>
            </template>
            <template v-else>
              <Button
                :to="child.attributes.slug"
                class="c-cms-menu__nav-button"
              >
                {{ child.attributes.libelle }}
              </Button>
            </template>
          </template>
        </ListItem>
      </List>
    </div>

    <div
      v-if="currentChild && currentChild.attributes.children && currentChild.attributes.children.data &&currentChild.attributes.children.data.length > 0"
      class="c-cms-menu-layer__panel"
    >
      <List>
        <ListItem
          v-for="(child, index) in currentChild.attributes.children.data"
          :key="`cms-menu-layer-${index}`"
          class="c-cms-menu-layer__item"
        >
          <Button
            class="c-cms-menu__nav-button"
            :to="child.attributes.slug"
          >
            {{ child.attributes.libelle }}
          </Button>
        </ListItem>
      </List>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-cms-menu-layer {
  height: 100%;

  .c-cms-menu__nav-button {
    justify-content: flex-start;
    width: 100%;
    padding: spacing(sm);
    position: relative;
    @include ie() {
      padding-right: 4rem;
    }
    &:hover,
    &:focus,
    .c-cms-menu-layer__item--active & {
      background-color: color(primary-lighter);
      color: color(primary-dark);
    }
    &.has-child {
      padding-right: 4rem;
      &:after {
        content: "";
        width: 2.4rem;
        height: 2.4rem;
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        background-image: url("@/assets/icons/arrow-right.svg");
        filter: invert(40%) sepia(1%) saturate(0%) hue-rotate(115deg)
          brightness(99%) contrast(87%);
        /*
        * Couleur : text-light;
        * Outil pour générer le filter : https://codepen.io/sosuke/pen/Pjoqqp
        */
        background-position: center;
        background-repeat: no-repeat;
        background-size: auto 2.4rem;
      }
      &:hover,
      &:focus {
        &:after {
          filter: invert(16%) sepia(100%) saturate(2642%) hue-rotate(189deg)
            brightness(96%) contrast(97%);
          /*
          * Couleur : primary-dark;
          * Outil pour générer le filter : https://codepen.io/sosuke/pen/Pjoqqp
          */
        }
      }
    }
  }
}
.c-cms-menu-layer__panel {
  background-color: color(white);
  //padding: spacing(sm);
  height: 100%;
  min-width: 250px;
}
.c-cms-menu-layer__panel--opened {
  box-shadow: 2px 0 6px rgba(0, 0, 0, 0.16);
  z-index: 2;
}
.c-cms-menu-layer__item {
  border-bottom: 1px solid color(grey-5);
  &:last-child {
    border-bottom: none;
  }
}
</style>
